export default "__VITE_ASSET__bdd4580b__"